// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"169":"view-auth-TokenLogin-vue","342":"view-auth-EmailLogin-vue","353":"view-Dashboard-vue"}[chunkId] + "-legacy." + {"169":"4685facc","342":"06623143","353":"6944dccc"}[chunkId] + ".js";
};